const sliderOptions = {
    loop: true,
    spaceBetween: 20,
    speed: 1000,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
};

let init = false;
let swiper;
function swiperAreas() {
    if (window.innerWidth <= 639) {
        if (!init) {
            init = true;
            swiper = new Swiper(".areas__slider", sliderOptions);
            
        }
    } else if (init) {
        swiper.destroy();
        init = false;
    }
}
swiperAreas();
window.addEventListener("resize", swiperAreas);

